import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import Button from '@material-ui/core/Button';

import ProfileField from './ProfileField';
import ModalBox from '../Common/Modals/ModalBox';

import { API, profileOptions } from '../../ws/constants';

import './style.css';

class UserProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userId:this.props.props.match.params.id
            , userName:this.props.props.match.params.name
            , openModal:false
            , loading:true
            , returnTitle: "Erro"
            , returnText: "Ocorreu algum erro"
            , editable: (this.props.isAdmin || (this.props.loginData.profile.Users && this.props.loginData.profile.Users.permission === 1))
        };
    }

    componentDidMount() {       
        this.setState({loading:false});     

        if(this.state.editable) {
            fetch(API + 'getprofile&userid='+this.state.userId)
            .then(response => response.json())
            .then(result => {
                const fields = result.data;
                const newState = { loading: false };
    
                for (let page in fields) {
                    const pageInfo = fields[page];
                    if (fields.hasOwnProperty(page)) {
                        const fieldName = pageInfo.Field ? pageInfo.Page + "_" + pageInfo.Field : pageInfo.Page;
                        newState["f_" + fieldName] = pageInfo.Permission;
                    }
                }
                this.setState(newState);            
            });
        }else{            
            this.props.props.history.push('/Clients');
        }
    }

    handleToggle = (e, fieldsList) => {
        const fieldName = e.target.name;
        const fieldValue = e.target.value;

        if(fieldsList){
            const newState = {
                [fieldName]: e.target.checked && fieldValue
            };

            for (let field in fieldsList) {
                if (fieldsList.hasOwnProperty(field)) {
                    const isValidValue = profileOptions[fieldName.substring(2)].fields[field].validValues.includes(fieldValue);
                    newState[fieldName + "_" + field] = e.target.checked && isValidValue && fieldValue;
                }
            }

            this.setState(newState);
        }else{
            this.setState({[fieldName]: e.target.checked && fieldValue});
        }
    }


    handleSave = (e) => {
        let DEFAULT_QUERY = "saveprofile&userid=" + this.state.userId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

        this.setState({loading:true});

        for (let field in this.state) {
            if (this.state.hasOwnProperty(field) && field.substring(0, 2) === "f_" && this.state[field] > 0) {
                DEFAULT_QUERY += "&"+field.substring(2)+"="+this.state[field];
            }
        }
        fetch(API + DEFAULT_QUERY)
        .then(response => response.json())
        .then(result => this.setState({ 
            returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro"
            , returnText: result.message
            , openModal: true
            , loading:false 
        }));
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        //this.props.props.history.push('/Users');
    }

    renderProfile = () => {
        const pages = [];

        for (let page in profileOptions) {
            if (profileOptions.hasOwnProperty(page) && !profileOptions[page].isSubPage) {
                pages.push(this.renderProfilePage(page));
            }
        }
        return pages;
    }

    renderProfilePage(page) {
        const pageInfo = profileOptions[page];
        const pageInfoFields = pageInfo.fields;
        const pageInfoSubPages = pageInfo.subPages || [];
        const pageClass = pageInfo.isSubPage ? "col-sm-10" : "col-sm-6"
        const fields = [];   
        const subPages = [];   

        for (let field in pageInfoFields) {
            if (pageInfoFields.hasOwnProperty(field)) {
                const thisField = {...pageInfoFields[field], fieldName: field};
                fields.push(<ProfileField key={page + "_" + field} 
                                          fieldInfo={thisField} 
                                          page={page} 
                                          disabled={!this.state.editable}
                                          handleToggle={this.handleToggle} 
                                          checkedValue={this.state["f_" + page + "_" + field]} />);
            }
        }  

        for (let i=0, n=pageInfoSubPages.length; i<n; i++) {
            subPages.push(this.renderProfilePage(pageInfoSubPages[i]));
        }

        return (
            <div className={pageClass} key={page}>
                <ProfileField 
                    mainField
                    key={page}    
                    page={page}                            
                    fieldInfo={pageInfo} 
                    disabled={!this.state.editable}
                    handleToggle={this.handleToggle} 
                    checkedValue={this.state["f_" + page]} 
                />
                {fields}
                { Boolean(subPages.length) &&
                    <div className="row">   
                        <div className="col-sm-2"></div>            
                        {subPages}
                    </div>
                }
            </div>
        );
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <div id="userProfile" className={"form addEditPage" + loadingClass}>
                <div className="row">
                    <div className="col-12">
                        <h1><i className="far fa-id-badge"></i> Perfil de {this.state.userName}</h1>
                    </div>
                </div>
                { (isAdmin || loginData.profile.Users) && 
                    <div className="row">
                        <div className="col-12">
                            <span className="float-right"><i className="fa fa-users"></i> <NavLink to={"/Users/"+this.state.userId}>Ver utilizador</NavLink></span>
                        </div>
                    </div>
                }
                <div className="row">
                    { this.renderProfile() }
                </div>
                <div className="row">
                    <div className="col-12 buttonsHolder">
                        <Button onClick={this.props.props.history.goBack} variant="contained" className="defaultButton">Voltar</Button>
                        {this.state.editable && <Button onClick={this.handleSave} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default UserProfile;
